import { createAsyncThunk } from '@reduxjs/toolkit';
import { VehicleServicesService } from '../../../epics/common/commonData';
import {
    namePlacementKey,
    typePlacementKey,
} from '../thunkKeys/placementThunksKeys';

export const getNamePlacement = createAsyncThunk(
    namePlacementKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehicleServicesService.getNamePlacement();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTypePlacement = createAsyncThunk(
    typePlacementKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehicleServicesService.getTypePlacement();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);
